import * as Sentry from '@sentry/browser';
import { html, LitElement } from 'lit';
import { buildURL, fetchRequest } from 'Utils/api-fetch-request';

import Styles from './vm-kol-profile-page-video-list.scss';

export default class VmKolProfilePageVideoList extends LitElement {
    static styles = Styles;
    static PAGINATION_LIMIT = 25;
    static API_BASE_URL = '/api/videos/kol/';
    static SORTING_OPTIONS = [
        { label: 'Newest', param: '-created' },
        { label: 'Relevance', param: '-relevance' },
        { label: 'Views', param: '-views' },
        { label: 'Thumbs up', param: '-thumbsup' },
        { label: 'Comments', param: '-comments' },
    ];

    static properties = {
        kolUuid: { type: String },
        kolProfileStatistics: { type: Object },
        videoItems: { state: true },
        pagination: { state: true },
        dataLoaded: { state: true },
        pageIndex: { state: true },
        sortValue: { state: true },
    };

    constructor() {
        super();

        this.sortValue = this.constructor.SORTING_OPTIONS[0].param;
        this.pageIndex = 1;
        this.dataLoaded = false;
        this.kolProfileStatistics = {};
    }

    async fetchVideoItems() {
        const params = {
            ordering: this.sortValue,
            limit: this.constructor.PAGINATION_LIMIT,
            offset: (this.pageIndex - 1) * this.constructor.PAGINATION_LIMIT,
        };

        const url = buildURL(`${this.constructor.API_BASE_URL}${this.kolUuid}/`, params);

        this.videoItems = [];
        this.dataLoaded = false;

        try {
            const { count, results } = await fetchRequest(url);
            const totalPages = Math.ceil(count / this.constructor.PAGINATION_LIMIT);
            this.videoItems = results;
            this.pagination = {
                count,
                totalPages,
            };

            this.dataLoaded = true;
        } catch (error) {
            Sentry.captureException(error);
        }
    }

    async connectedCallback() {
        super.connectedCallback();
        await this.fetchVideoItems();
    }

    handlePaginationClick(e) {
        this.pageIndex = e.detail.pageIndex;
        this.fetchVideoItems();
    }

    handleSortChange(e) {
        this.pageIndex = 1;
        this.sortValue = e.detail.sortObject.param;
        this.fetchVideoItems();
    }

    render() {
        return html`
            <div class="kol-profile__content-header">
                <h3 class="kol-profile__content-title">All Videos</h3>
                <vm-sort-dropdown
                    .options=${this.constructor.SORTING_OPTIONS}
                    @vm-sort-change=${(e) => this.handleSortChange(e)}
                ></vm-sort-dropdown>
            </div>

            <div class="kol-profile__content-stats">
                <p>${this.kolProfileStatistics?.video_count} videos</p>
                <span>·</span>
                <p>${this.kolProfileStatistics?.educated_count} doctor educated</p>
                <span>·</span>
                <p>${this.kolProfileStatistics?.minutes_viewed} minutes viewed</p>
            </div>

            <div class="kol-profile__video-list">
                ${this.dataLoaded
                    ? html`
                          ${this.videoItems.length === 0
                              ? html` <p class="kol-profile__no-videos-message">No videos found.</p> `
                              : this.videoItems?.map(
                                    (v) =>
                                        html` <vm-kol-profile-page-video-list-item
                                            .video="${v}"
                                        ></vm-kol-profile-page-video-list-item>`,
                                )}
                          ${this.pagination.totalPages > 1
                              ? html`
                                    <vm-list-pagination
                                        .totalPages=${this.pagination.totalPages}
                                        .currentPage=${this.pageIndex}
                                        @vm-pagination-click="${(e) => this.handlePaginationClick(e)}"
                                    ></vm-list-pagination>
                                `
                              : ''}
                      `
                    : html`<vm-loading-spinner size="3"></vm-loading-spinner>`}
            </div>
        `;
    }
}
